import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import ProductDetails from './ProductDetails';
import RateCard from '../RateCard';
import { isInteger, toSafeInteger } from 'lodash';
import $ from 'jquery';

import toastr from 'toastr'
import Progress from '../Progress'

function Step4() {
    const authContext = useContext(AuthContext);
    let { step, gotoNextStep, lp, lead, } = authContext;
    let { enable_rate_card_equipment } = lp;
    let thisProd;
    let thisProdType;
    lp.products.forEach((item) => {
        let $match = item.types.find(x => x.id === lead.offer.product_type_id);
        if ($match) {
            thisProdType = $match;
        }
        if (item.id === lead.offer.product_id) {
            thisProd = item;
        }
    });
    // console.log(thisProd, lp.products, lead.offer.product_id);
    let thisProdExtras = [];
    if (thisProdType) {
        thisProdExtras = thisProdType.extras;
    }
    let $stateExtras = [];
    thisProdExtras.forEach((item) => {
        let $elem = {};
        $elem.id = item.id;
        $elem.qty = 1;
        $elem.price = item.price;
        $stateExtras.push($elem);
    });
    const getCurrentOrDefaultOption = () => {
        let option = lead.offer.product_option_id;
        let $match;
        if (option) {
            $match = thisProd.options.find(x => x.id === lead.offer.product_option_id);
            if (!$match) {
                option = null;
            }
        } else {
            if (!thisProd.options.length) {
                option = null;
            } else {
                option = thisProd.options[0].id; // first is the default one (ordered by backend scope)
            }
        }
        return option;
    }
    const initialState = {
        offerId: lead.offer ? lead.offer.id : null,
        extra: lead.offer.extras_json ? lead.offer.extras_json : [],
        carditems: lp ? thisProd.ratecarditems : [],
        option: getCurrentOrDefaultOption(),
        prodQty: lead.offer ? lead.offer.product_qty : 1,
        special_requirements: lead.offer ? lead.offer.special_requirements : ''
    }


    const [fields, setFields] = useState(initialState);
    const handleExtras = (val) => {
        let $current = fields.extra;
        const exists = search(val, $current);
        if (isInteger(exists)) {
            $current = $current.filter((c) => { return c.id !== val })
        } else {
            if ($current.length <= 4) {
                $current.push({ id: val, qty: 1 })
            } else {
                toastr.error('You can only select up to 5 extras per product', 'Error...');
                $(`#extra${val}`).prop('checked', false);
            }
        }
        setFields({
            ...fields,
            extra: $current,
        });
    }
    const handleExtraQty = (id, qty) => {
        let $current = fields.extra;
        const exists = search(id, $current);
        if (isInteger(exists)) {
            $current[exists].qty = parseInt(qty);
        }
        setFields({
            ...fields,
            extra: $current,
        });
    }
    const handleProdQty = (qty) => {
        setFields({
            ...fields,
            prodQty: parseInt(qty),
        });
    }
    const setRequirements = (value) => {
        setFields({
            ...fields,
            special_requirements: value
        })
    }

    const handleOptions = (val) => {
        setFields({
            ...fields,
            option: val,
        });
    }

    let product = {
        name: thisProd.name,
        id: lead.offer.product_id,
        type: thisProdType,
        currentExtras: fields.extra,
        qty: fields.prodQty,
        options: thisProd.options
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        gotoNextStep(fields, step);
    }
    const search = (nameKey, myArray) => {
        for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].id === nameKey) {
                return i;
            }
        }
        return 'null';
    };
    return (
        <>
            <form action="" onSubmit={e => handleSubmit(e)} method="POST">
                <div className="container-fluid">
                    <Progress step={step} />
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <ProductDetails product={product} handleProdQty={handleProdQty} handleExtras={handleExtras} handleExtraQty={handleExtraQty} handleOptions={handleOptions} option={fields.option} />
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="form-group">
                                <label className="mt-3 special_req d-block">Let us know if you have any special requirements:</label>
                                <textarea name="special_requirements" onChange={(e) => setRequirements(e.target.value)} className="form-control" >{fields.special_requirements}</textarea>
                            </div>
                        </div>
                        <div className="col-md-8">
                            {enable_rate_card_equipment ?
                                <RateCard carditems={fields.carditems} />
                                : ''}
                        </div>
                    </div>
                    <SubmitForm />
                </div>
            </form>
        </>
    )
}

export default Step4
